export default __webpack_public_path__ + "static/media/11.962f498b.jpg";